import React, { useState } from 'react';

type StatusBadgeProps = {
  quantity: number;
  shipQtd: number;
};

export const STATUS_OPTIONS = [
  { value: 'OK', label: 'OK', color: 'bg-green-100 text-green-700' },
  { value: 'NO', label: 'Not OK', color: 'bg-red-100 text-red-700' },
  { value: 'OVER', label: 'Over', color: 'bg-yellow-100 text-yellow-700' },
  { value: 'NA', label: 'Not Applicable', color: 'bg-gray-100 text-gray-700' },
];

export const calculateStatus = (quantity: number, shipQtd: number): string => {
  if (shipQtd === 0 && quantity === 0) return 'NA';
  if (quantity === shipQtd) return 'OK';
  if (quantity < shipQtd) return 'NO';
  return 'OVER';
};

const getTooltip = (status: string): string => {
  switch (status) {
    case 'NA': return 'Not applicable: no items expected or shipped';
    case 'OK': return 'All items correctly';
    case 'NO': return 'Some items are missing';
    case 'OVER': return 'Too many items';
    default: return '';
  }
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ quantity, shipQtd }) => {
  const status = calculateStatus(quantity, shipQtd);
  const { label, color } = STATUS_OPTIONS.find(opt => opt.value === status) || STATUS_OPTIONS[3];
  const tooltip = getTooltip(status);

  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {showTooltip && (
        <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 bg-gray-800 text-white text-xs rounded px-2 py-1 z-10 whitespace-nowrap">
          {tooltip}
        </div>
      )}
      <span className={`inline-block px-2 py-1 rounded text-xs font-semibold ${color}`}>
        {label}
      </span>
    </div>
  );
};
